import * as tslib_1 from "tslib";
/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-11-12 11:53:15
 * @LastEditors: baidongsheng
 * @LastEditTime: 2021-12-30 20:03:48
 */
import "babel-polyfill";
import "./config/axios";
import env from "@/config/env";
import * as platform from "@cloudpivot/platform";
import { formApi } from "@cloudpivot/api";
import md5 from "md5";
import { startup } from "./startup";
import initFormComponent from "@cloudpivot/form/registerComponent";
import common from "@cloudpivot/common/mobile";
import Vues from "vue";
import infiniteScroll from "vue-infinite-scroll";
import axios from "axios";
//引入svg
import './assets/icons/iconfont.js';
import { setToken } from '../../../config/dev';
setToken();
function getYSTokenBygzhbToken(xgToken) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        // 用工作汇报token换取云枢token
        const isDev = process.env.NODE_ENV === "debug";
        let uri = `${env.apiHost}/api/login/cworksso?code=${xgToken}`;
        const cfg = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        if (isDev) {
            uri = uri.replace("/api", "");
        }
        else {
            uri = `${location.origin}` + `/api/login/cworksso?code=${xgToken}`;
        }
        const { errcode, access_token, errmsg, resultMsg } = (yield axios.post(uri, cfg));
        if (errcode === 0) {
            let YSToken = access_token;
            localStorage.setItem('token', YSToken);
        }
    });
}
Vues.use(infiniteScroll);
// localStorage.setItem('token', 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiYXBpIl0sImNvcnBJZCI6bnVsbCwidXNlcl9pZCI6IjJjOWY4ZGVjN2Q3ZTMxYzQwMTdkN2UzOGUzYWYwMDA1IiwidXNlcl9uYW1lIjoiMTczOTYyMzgyODQiLCJzY29wZSI6WyJyZWFkIl0sIm1vYmlsZSI6ZmFsc2UsImlzQWRtaW4iOnRydWUsImV4cCI6MTY1OTcyNjA3NywiaXNBcHBBZG1pbiI6ZmFsc2UsImF1dGhvcml0aWVzIjpbIlVTRVIiLCJBVVRIX1NZU1RFTV9NQU5BR0UiXSwianRpIjoiN2E3Njk1YTktNWJmYy00NmJmLTg0NGMtZDQzYjNiNDkzYzljIiwiY2xpZW50X2lkIjoiYXBpIn0.FUGjFn-hVNJqsY0ExWtlY2DEjWlaQCzORvUqGqSD_TuzwpFwhE-o0rGfLB7M5y6Zn5tYasNOk7v6Gbm_6NGjz4suoA5iW9zcgInxKs5qwwxvIyQTRjZa9p3CTknvYXV8GfqNqwV458WaeEmfZTvhcpryaV1n6IEpard_C4gBjRlClDo23PFdJ8wWBdFktyVc0xtJ8c_NX9iLXchibaiR9fkL5HopcfqN79qh3L8mGEiiBaIQlH3d3leuR9sCxFjof4sveirBWoyUh6O3_6WbYy9uU0kymhW5rKeMOb3n_owgIBwxK8nI6jhTjve1XQy35hdn1u64j-3KmdlvKmtcgA');
initFormComponent();
Promise.resolve().then(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
    // 本地有工作汇报token,换取云枢token
    const gzhbLoginYSToken = sessionStorage.getItem('gzhbLoginYSToken');
    if (gzhbLoginYSToken) {
        yield getYSTokenBygzhbToken(gzhbLoginYSToken).finally(() => {
            sessionStorage.removeItem('gzhbLoginYSToken');
        });
    }
})).finally(() => {
    platform.start(env.client_id, env.scope).then((result) => {
        if (!result)
            return;
        const { query } = result;
        if (query.messageId && common.utils.Common.isPC) {
            openMessage(query.messageId);
        }
        else if (query.messageId && !common.utils.Common.isPC) {
            window.location.href = `${env.portalHost}/mobile/?messageId=${query.messageId}`;
        }
        else {
            startup(query);
            // import(/* webpackChunkName: "startup" */'./startup').then( obj => {
            //   obj.startup(query);
            // });
        }
    });
});
Vues.prototype.getPopupContainer = (triggerNode) => {
    // console.log(triggerNode,'triggerNodetriggerNode',triggerNode.parentNode)
    return triggerNode.parentNode.parentNode;
};
Vues.prototype.$md5 = md5;
window.$md5 = md5;
/**
 * 根据消息打开页面
 * @param messageId
 */
function openMessage(messageId) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const $app = document.getElementById("app");
        if (!$app) {
            throw new Error(`can't find #app`);
        }
        const params = {
            messageId
        };
        const token = localStorage.getItem("token");
        if (token) {
            const res = yield formApi.getMessageFormUrl(params);
            if (res.errcode === 0 && res.data) {
                // 跳转到消息地址或者第三方浏览器直接打开地址
                const { bizObjectId, workItemId, workflowInstanceId, schemaCode, sheetCode, url } = res.data;
                // alert(`结果详情：bizobjectid:${bizObjectId},workitemid:${workItemId},workflowinstanceid:${workflowInstanceId}`);
                let theUrl = "";
                if (url) {
                    if (url.indexOf("?") > -1) {
                        theUrl = `${url}&T=${token}`;
                    }
                    else {
                        theUrl = `${url}?T=${token}`;
                    }
                }
                else {
                    if (schemaCode === 'jiandangdan') {
                        theUrl = `${env.portalHost}/dangan-detail?`;
                        theUrl += `objectId=${bizObjectId}&schemaCode=${schemaCode}&sheetCode=${sheetCode}&T=${token}`;
                    }
                    else if (schemaCode === 'topicArchival') {
                        theUrl = `${env.portalHost}/topics-detail?`;
                        theUrl += `objectId=${bizObjectId}&schemaCode=${schemaCode}&sheetCode=${sheetCode}&T=${token}`;
                    }
                    else {
                        theUrl = `${env.portalHost}/form/detail?`;
                        if (workflowInstanceId) {
                            theUrl += `workflowInstanceId=${workflowInstanceId}&workitemId=${workItemId ||
                                ""}&T=${token}`;
                        }
                        else {
                            theUrl += `objectId=${bizObjectId}&schemaCode=${schemaCode}&sheetCode=${sheetCode}&T=${token}`;
                        }
                    }
                }
                $app.innerText = "";
                $app.style.textAlign = "center";
                $app.style.paddingTop = "20px";
                $app.style.color = "#666";
                $app.style.fontSize = "18px";
                const $a = document.createElement("a");
                $a.style.textDecoration = "underline";
                $a.href = theUrl;
                $a.target = "_blank";
                $a.innerText = "浏览器打开应用";
                $app.appendChild($a);
                // window.location.href = theUrl;
                platform.service.openLink(theUrl);
            }
        }
        else {
            localStorage.setItem("isShowEmailResquest", `${env.portalHost}?messageId=${messageId}`);
            const theUrl = `${env.portalHost}/login`;
            window.location.href = theUrl;
        }
    });
}
